export const CLIENT_CURRENT_STATUS = {
    active: {
        en: 'Active',
        es: 'Activo'
    },
    out: {
        en: 'Out of Business',
        es: 'El negocio ha cerrado'
    },
    bankruptcy: {
        en: 'Bankruptcy',
        es: 'Bancarrota'
    },
    away: {
        en: 'Moved Away',
        es: 'Se mudó'
    },
    sold: {
        en: 'Sold',
        es: 'Vendido'
    },
    unknown: {
        en: 'Unknown',
        es: 'Desconocido'
    }
} as Record<string, { en: string; es: string }>;
